import type { FaireProductEntity } from "../../entity_types/product";

export const p_chx0gqq4eh: FaireProductEntity = {
  token: "p_chx0gqq4eh",
  type: "product",
  name: "Baby Smiley Beanie - Cute and Cozy Infant Hat with Smiley",
  brandToken: "b_32rsz10vd0",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/c83d4b1d7b38a07a5758d2711699f0ca30b0ebcfe4c02e2ca1374ab5c6b3429a.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/0461e70defd968b8811895ea015ad0ba78195412af3a7ff49629308343acc8e1.jpeg",
    "https://cdn.faire.com/fastly/2088e3c948cefbcf42be792840172d663682421d12cd897f26a273ac6d4d66e2.jpeg",
  ],
  priceDollars: 7,
  description:
    "🧢 Keep your baby warm and stylish with the Baby Smiley Beanie! Designed for infants and toddlers, this super soft knit hat features a cheerful smiley face design, bringing a touch of fun to cold-weather outfits. Perfect for boys and girls, this cozy beanie is ideal for winter outings, stroller rides, and outdoor play. A must-have for your little one’s fall and winter wardrobe, it also makes a sweet gift for baby showers, birthdays, and holiday surprises!\n\nWhy You’ll Love It:\n😊 Adorable Smiley Face Design – Adds a fun, cheerful touch\n🧶 Soft & Cozy Knit Fabric – Made for all-day comfort & warmth\n👶 Unisex & Versatile – Perfect for baby boys & girls\n❄️ Ideal for Winter & Outdoor Play – Keeps little heads snug & warm\n🎁 Great Gift Idea – Perfect for new parents, baby showers & holidays\n\n📏 Material: 100% Acrylic for warmth & stretch\n\n🍼✨ Wrap your little one in warmth and cuteness—shop the Baby Smiley Beanie now! ✨🧢",
  tags: [],
  msrpDollars: 14,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:25:21.900Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
